import React from 'react';
import './_changeLog.scss';

const ChangeLogSectionImage = ({ imageUrl, title }) => {
  if (!Boolean(imageUrl?.length)) {
    return <></>;
  }

  return (
    <div className="change-log-section-image-container">
      <img className="change-log-section-image" src={imageUrl} alt={title} />
    </div>
  );
};

export default ChangeLogSectionImage;
